var React = require('react');

function Handle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M48,12c0,-6.623 -5.377,-12 -12,-12l-24,0c-6.623,0 -12,5.377 -12,12l0,81c0,6.623 5.377,12 12,12l24,0c6.623,0 12,-5.377 12,-12l0,-81Z","style":{"fill":"#efefef"},"key":0}),React.createElement("path",{"d":"M393,12c0,-6.623 -5.377,-12 -12,-12l-24,0c-6.623,0 -12,5.377 -12,12l0,81c0,6.623 5.377,12 12,12l24,0c6.623,0 12,-5.377 12,-12l0,-81Z","style":{"fill":"#efefef"},"key":1}),React.createElement("path",{"d":"M36,57c-6.623,0 -12,5.377 -12,12l0,24c0,6.623 5.377,12 12,12l321,0c6.623,0 12,-5.377 12,-12l0,-24c0,-6.623 -5.377,-12 -12,-12l-321,0Z","style":{"fill":"#efefef"},"key":2})]);
}

Handle.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 393 105","version":"1.1","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = Handle;

Handle.default = Handle;
